<template>
  <nav class="navbar navbar-white">
    <!-- 서비스 로고 영역 -->
    <router-link to="/" class="navbar-brand">
      <img src="~@/assets/svg/logo/logo-biz.svg" class="img-responsive" alt="Bizhaezoom Logo">
    </router-link>
    <div class="collapse navbar-collapse">
      <!-- 서비스 카테고리 영역 -->
      <ul v-if="menuList.length > 0" class="navbar-nav">
        <li :class="['nav-item', {'active': menu.code === currentTab }]"
            v-for="menu in menuList"
            :key="menu.name">
          <a class="nav-link" href="javascript:void(0);">{{ menu.name }}</a>
        </li>
        <!-- GNB 영역 메뉴 :hover 시 하단에 출력되는 전체 메뉴 레이어 -->
        <li class="nav-full-menu">
          <ul class="nav-menu">
            <li v-for="menu in menuList" :key="menu.name" class="nav-menu-item">
              <router-link class="nav-menu-link"
                           v-for="children in menu.children"
                           :key="children.name"
                           :to="children.path"
                           @click.native="close()">{{ children.name }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <!-- 로그인, 회원가입, 유저정보 영역 -->
      <ul class="navbar-nav navbar-right padding-0">
        <!-- 로그인 했을 경우 -->
        <li v-if="user.id" class="nav-item-sub padding-0">
          <div class="nav-user">
            <router-link v-if="showRestDays" to="/coupon"
                         :class="['charge-info', {'near': user.rest_days <= 5}]">{{ user.rest_days }}일 남음</router-link>
            <router-link v-else to="/pricing" class="charge-info">이용권</router-link>
          </div>
          <div class="nav-menu-hamburger collapsed">
            <i class="glyphicon glyphicon-menu-hamburger"></i>
          </div>
          <div class="nav-user-menu">
            <router-link to="/mypage">마이페이지</router-link>
            <router-link to="/coupon">이용권관리/쿠폰함</router-link>
            <router-link to="/admin" target="_blank" v-if="user.auth_level === '90'">회원사관리</router-link>
            <a href="#" @click.prevent="showLogoutModal">로그아웃</a>
          </div>
        </li>
        <!-- 로그인 하지 않았을 경우 -->
        <li v-if="!user.id" class="nav-item-sub">
          <router-link to="/register" class="nav-register">회원가입</router-link>
        </li>
        <li v-if="!user.id" class="nav-item-sub">
          <router-link to="/login" class="nav-login hz-btn-primary">로그인</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'gnb',
    data () {
      return {
        logoImage: require('../assets/svg/logo/logo-biz.svg')
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        basicMenuList: 'basicMenuList'
      }),
      menuList () {
        /**
         *
         * GNB 출력항목이 바인딩 될 수 있게끔 가공합니다.
         * 로그인 여부에 따라 가공 기준이 되는 메뉴가 구분됩니다. (basicMenu/userMenu)
         * 각 메뉴에 level, parent_code 값으로 구분하여 가공된 데이터를 반환합니다.
         */

        const basic = this.basicMenuList
        const user = this.user
        const isLogin = user.isLogin
        // 로그인 했을 경우 사용자에게 주어진 메뉴 목록을 넣어주고, 안했을 경우 기본 메뉴 목록을 넣어준다.
        const serviceList = isLogin ? user.serviceList : basic.serviceList
        let parseServiceList = []

        if (serviceList && serviceList.length > 0) {
          // GNB 레이어에 출력된 level === 0에 항목을 리스트로 만들어준다.
          const parent = _.filter(serviceList, (o) => { return o.level === 0 })
          if (parent.length > 0) {
            // 부모 카테고리 갯수만큼 반복문을 실행한다.
            for (let i in parent) {
              // 부모 카테고리에 code 값을 parent_code로 가진 항목을 분류하여 하위 카테고리로 넣어준다. (children)
              const children = _.filter(serviceList, (o) => { return o.level !== 0 })
              const menuObj = Object.assign(parent[i], {
                children: _.filter(children, (o) => { return o.parent_code === parent[i].code })
              })

              // 부모-자식 형태로 가공된 객체를 반환될 리스트에 넣어준다.
              parseServiceList.push(menuObj)
            }
          }
        }

        // 가공된 데이터를 반환한다.
        return parseServiceList
      },
      currentTab () {
        // 현재 URL에 상위 코드값으로 해당되는 GNB 카테고리를 active 처리한다.
        const route = this.$route
        const meta = route.meta
        const parentCode = meta.hasOwnProperty('parentCode') ? meta.parentCode : ''

        return parentCode
      },
      showRestDays () {
        const user = this.user
        const restDays = user.rest_days
        const flag = restDays !== '' && restDays >= 0

        return flag
      }
    },
    methods: {
      close () {
        // 네비게이션 클릭 시 하단에 출력되는 창을 닫는다.
        const el = this.$el
        const menu = el.querySelector('.nav-full-menu')

        if (menu) {
          // 네비게이션 레이어에 none 속성 처리
          menu.setAttribute('style', 'display: none')
          // 인라인 태그에 none 속성이 들어갈 경우, 정의해놓은 :hover css가 동작안하기에 0.5초뒤에 해당 속성을 제거한다.
          setTimeout(() => { menu.removeAttribute('style') }, 500)
        }
      },
      showLogoutModal: function () {
        this.$emit('showLogoutModal')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/gnb';

  .navbar {
    .has-notice & {
      top: 64px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Gnb.vue